import * as React from "react"

function SmileIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={50}
      height={50}
      viewBox="0 0 368 368"
      {...props}
    >
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M184 8c97.2 0 176 78.8 176 176s-78.8 176-176 176S8 281.2 8 184 86.8 8 184 8zm80 144c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16zm-128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16z"
          fill="#d5ccf5"
          data-original="#cce4ff"
        />
        <circle
          cx={248}
          cy={152}
          r={16}
          fill="#d5ccf5"
          data-original="#cce4ff"
        />
        <circle
          cx={120}
          cy={152}
          r={16}
          fill="#d5ccf5"
          data-original="#cce4ff"
        />
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M184 0C82.544 0 0 82.544 0 184s82.544 184 184 184 184-82.544 184-184S285.456 0 184 0zm0 352c-92.64 0-168-75.36-168-168S91.36 16 184 16s168 75.36 168 168-75.36 168-168 168z"
          fill="#3c096c"
          data-original="#007aff"
        />
        <path
          d="M144 152c0-13.232-10.768-24-24-24s-24 10.768-24 24 10.768 24 24 24 24-10.768 24-24zm-32 0c0-4.408 3.592-8 8-8s8 3.592 8 8-3.592 8-8 8-8-3.592-8-8zM248 128c-13.232 0-24 10.768-24 24s10.768 24 24 24 24-10.768 24-24-10.768-24-24-24zm0 32c-4.408 0-8-3.592-8-8s3.592-8 8-8 8 3.592 8 8-3.592 8-8 8zM250.032 226.664C233.36 245.312 209.296 256 184 256c-25.224 0-49.304-10.696-66.048-29.344a7.983 7.983 0 00-11.296-.608 7.998 7.998 0 00-.608 11.296C125.824 259.368 154.24 272 184 272c29.84 0 58.256-12.64 77.968-34.664a7.999 7.999 0 00-.632-11.296c-3.304-2.944-8.36-2.672-11.304.624z"
          fill="#3c096c"
          data-original="#007aff"
        />
      </g>
    </svg>
  )
}

export default SmileIcon;